import { sanitizeUrl } from '@braintree/sanitize-url';


/**
 * Helper pour la gestion de divers comportements front.
 */
export class CoreHelper {

  /**
   * Permets de lutter contre les Cross-Site Scripting (XSS).
   * @param chaine chaine à nettoyer
   * @returns La chaine nettoyée.
   */
  public static Sanitize(chaine: string) {
    return sanitizeUrl(chaine);
  }


  
}
